/**
 * The Apptonomy wordmark, parked in the slide's top-right corner.
 *
 * The cover carries the full-size wordmark in its own header, so this is for
 * every other slide: same asset, roughly half the height, so a slide read on
 * its own — exported, screenshotted, or projected out of order — still says
 * whose it is.
 *
 * Rendered by the deck runner into SlideFrame's `cornerSlot` and by PrintView
 * into each page, so the two surfaces cannot drift.
 */
export function DeckWordmark() {
  return (
    <img
      src="https://public.apptonomy.ai/a7y-wordmark-onlight.png"
      srcSet="https://public.apptonomy.ai/a7y-wordmark-onlight.png 1x, https://public.apptonomy.ai/a7y-wordmark-onlight_2x.png 2x, https://public.apptonomy.ai/a7y-wordmark-onlight_3x.png 3x"
      alt="Apptonomy"
      aria-hidden="true"
      className="h-6 w-auto opacity-80"
    />
  );
}
